<template>
    <div class="main-wrap">
        <div class="game-wrap">
            <background-module></background-module>
            <spouse-module></spouse-module>
            <character-module></character-module>
            <monologue-module></monologue-module>

            <div class="game-layout">
                <v-layout class="top-modules">
                    <ages-module />
                    <factor-module />
                    <bomb-module />
                    <relation-module />
                </v-layout>

                <v-layout class="bottom-modules" justify-start align-center>
                    <img class="btn-logout" src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/btn_logout.png" @click="logout" />

                    <!--                    <audio-module />-->
                    <div class="btn-sound" @click="switchSound">
                        <img v-if="!isMuted" src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/btn_sound_on.png" />
                        <img v-else src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/btn_sound_off.png" />
                    </div>
                </v-layout>

                <question-module />
                <badge-module />

                <div class="explode"></div>
            </div>
        </div>

        <div class="intro-wrap">
            <intro-module></intro-module>
        </div>
        <div class="intro-continued-wrap">
            <v-layout class="intro-continued" justify-center align-center fill-height>
                <img src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/intro_continued.png" />
            </v-layout>
        </div>
        <age-intro-module></age-intro-module>
        <ending-module></ending-module>

<!--        <div class="for-dev">-->
<!--            <v-btn color="secondary" @click="clearData()">게임데이터 초기화</v-btn>-->
<!--        </div>-->

    </div>
</template>

<script>
    import BackgroundModule from "./modules/BackgroundModule";
    import CharacterModule from "./modules/CharacterModule";
    import AgesModule from "./modules/AgesModule";
    import FactorModule from "./modules/FactorModule";
    import BombModule from "./modules/BombModule";
    import RelationModule from "./modules/RelationModule";
    import QuestionModule from "./modules/QuestionModule";
    import IntroModule from "./modules/IntroModule";
    import MonologueModule from "./modules/MonologueModule";
    import SpouseModule from "./modules/SpouseModule";
    import AgeIntroModule from "./modules/AgeIntroModule";
    import EndingModule from "./modules/EndingModule";
    import BadgeModule from "./modules/BadgeModule";

    export default {
        components: {
            BackgroundModule,
            CharacterModule,
            AgesModule,
            FactorModule,
            BombModule,
            RelationModule,
            QuestionModule,
            IntroModule,
            MonologueModule,
            SpouseModule,
            AgeIntroModule,
            EndingModule,
            BadgeModule,
        },
        watch: {
            ages(val) {
                if (val) {
                    this.initGame()
                }
            },
            sequence(val) {
                this.storeUserData()
            }
        },
        data() {
            return {
                userData: this.$userData,
            }
        },

        computed: {
            ages() {
                return this.$gameData.ages
            },
            sequence() {
                return this.$userData.sequence
            },

            isMuted() {
                return this.$store.getters.isMuted
            },
        },
        beforeMount() {
            const id = this.$cookie.get('id')
            const localUserData = localStorage.getItem(`userData${id}`)
            if (localUserData) {
                const userData = JSON.parse(localUserData)
                Object.keys(userData).forEach(key => {
                    this.$set(this.$userData, key, userData[key])
                })
            }

            const localRoundData = localStorage.getItem(`roundData${id}`)
            if (localRoundData) {
                this.$roundData = JSON.parse(localRoundData)
            }

            this.$set(this.$userData, 'gender', this.$cookie.get('gender'))
        },
        beforeDestroy() {
            this.$eventBus.$off('ENDING_ENDED')
            this.$eventBus.$off('CHANGE_AGE')

            this.$eventBus.$off('ANIMATION_ENDED')
            this.$eventBus.$off('ADD_PENALTY')

            this.$eventBus.$off('INTRO_ENDED')
            this.$stopAll()
        },
        mounted() {
            this.$stopAll()

            this.$eventBus.$on('ENDING_ENDED', this.endingEnded)

            if (this.$userData.ended) {
                this.startEnding(true)
                return
            }

            if (this.ages) {
                this.initGame()
            }

            this.$eventBus.$on('CHANGE_AGE', this.changeAge)

            this.$eventBus.$on('ANIMATION_ENDED', this.onAnimationEnded)
            this.$eventBus.$on('ADD_PENALTY', this.addPenalty)

            this.$eventBus.$on('INTRO_ENDED', this.introEnded)


            this.startGame()
        },

        methods: {
            initGame() {
                if (!this.$userData.round) this.$userData.round = 1
                if (!this.$userData.age) this.$userData.age = 20

                this.$eventBus.$emit('SET_ROUND', this.$userData.round)
            },
            startGame() {

                if ((!this.$userData.age || this.$userData.age === 20) && !this.$userData.sequence) {
                    // $('.intro-wrap').addClass('show')
                    $('.intro-wrap').fadeIn(1000)
                    setTimeout(_ => {
                        this.$eventBus.$emit('START_INTRO')
                    }, 700)
                } else {
                    $('.intro-continued-wrap').fadeIn(1000, _ => {
                        setTimeout(_ => {
                            $('.intro-continued-wrap').fadeOut(1000, _ => {

                                this.moveStart()

                            })

                        }, 2000)
                    })
                }
            },
            moveStart() {

                if (!this.$userData.sequence) {
                    this.$userData.sequence = 1
                }

                $('.game-wrap').fadeIn()
                setTimeout(_ => {
                    this.$eventBus.$emit('START_MOVING')
                }, 2000)

                if ([20,30].indexOf(this.$userData.age) > -1) {
                    this.$playAudio(19)
                } else if ([40,50].indexOf(this.$userData.age) > -1) {
                    this.$playAudio(20)
                } else if (this.$userData.age === 60) {
                    this.$playAudio(21)
                } else if (this.$userData.age === 70) {
                    this.$playAudio(22)
                }
            },
            changeAge() {
                if (!this.$userData.round) {
                    this.$userData.round = 1
                }
                if (!this.$userData.age) {
                    this.$userData.age = 20
                } else {
                    if (this.$userData.age === 70) {
                        this.startEnding()
                        return
                    }
                    $('.game-wrap').fadeOut()
                    setTimeout(_ => {
                        this.$userData.age += 10
                        this.$userData.sequence = 0

                        this.showTitleLeaf()
                    }, 1000)

                }

            },

            showTitleLeaf() {
                this.$eventBus.$emit('SHOW_AGE_INTRO')
                setTimeout(_ => {
                    this.$userData.sequence = 1
                    this.moveStart()
                }, 4000)
            },

            onAnimationEnded() {
                // this.$userData.question = 1
                this.$eventBus.$emit('SHOW_QUESTION')
            },

            addPenalty() {
                this.$userData.penalty++

                if (this.$userData.penalty === 3) {
                    this.explode()
                    this.$playAudio(10)
                } else {
                    // this.playAudio(17)
                }
            },

            explode() {

                $('.game-wrap').addClass('shake')
                setTimeout(_ => {
                    $('.game-wrap').removeClass('shake')
                    this.$userData.factor1--
                    this.$userData.factor2--
                    this.$userData.factor3--
                    this.$userData.factor4--
                }, 1400)

            },

            introEnded() {
                // $('.intro-wrap').removeClass('show').addClass('hide')
                $('.intro-wrap').fadeOut(1000)
                setTimeout(_ => {
                    $('.game-wrap').fadeIn()
                }, 1000)

                this.$userData.age = 20
                this.$userData.sequence = 0

                this.showTitleLeaf()

            },

            startEnding(immediate) {
                this.$userData.ended = true

                const gainedBadges = []
                // 1 재력가 factor1 >= 65
                if (this.$userData.factor1 >= 75) {
                    this.$set(this.$userData.badges, 1, true)
                    gainedBadges.push(1)
                }
                // 4 슈퍼맨 factor2 >= 65
                if (this.$userData.factor2 >= 75) {
                    this.$set(this.$userData.badges, 4, true)
                    gainedBadges.push(4)
                }
                // 7 핵인싸 factor3 >= 65
                if (this.$userData.factor3 >= 75) {
                    this.$set(this.$userData.badges, 7, true)
                    gainedBadges.push(7)
                }
                // 10 지성인 factor4 >= 65
                if (this.$userData.factor4 >= 75) {
                    this.$set(this.$userData.badges, 10, true)
                    gainedBadges.push(10)
                }

                if (gainedBadges.length === 1) {

                }

                this.sendResult()

                this.storeUserData()
                this.$eventBus.$emit('START_ENDING', immediate)
                setTimeout(_ => {
                    $('.game-wrap').fadeOut(2000)
                }, immediate ? 0 : 3000)
            },

            endingEnded() {
                this.$roundData[this.$userData.round] = this.$userData
                this.storeUserData()
                this.$router.push('/result')
                this.$stopAll()
            },

            storeUserData() {
                const id = this.$cookie.get('id')
                localStorage.setItem(`userData${id}`, JSON.stringify(this.$userData))

                if (this.$roundData[this.$userData.round]) {
                    localStorage.setItem(`roundData${id}`, JSON.stringify(this.$roundData))
                }
            },

            logout() {
                this.$cookie.delete('id')
                this.$cookie.delete('name')
                this.$cookie.delete('token')
                this.$router.push('/login')

                this.$eventBus.$emit('SOCKET_CLOSE')
                this.$stopAll()
            },

            switchSound() {
                this.$playAudio(1)
                this.$toggleMute()
                // this.$store.commit('setMute', !this.isMuted)
            },

            sendResult() {
                const params = {
                    round: this.$userData.round,
                    factor1: this.$userData.factor1,
                    factor2: this.$userData.factor2,
                    factor3: this.$userData.factor3,
                    factor4: this.$userData.factor4,
                    badge1: this.$userData.badges[1],
                    badge2: this.$userData.badges[2],
                    badge3: this.$userData.badges[3],
                    badge4: this.$userData.badges[4],
                    badge5: this.$userData.badges[5],
                    badge6: this.$userData.badges[6],
                    badge7: this.$userData.badges[7],
                    badge8: this.$userData.badges[8],
                    badge9: this.$userData.badges[9],
                    badge10: this.$userData.badges[10],
                    badge11: this.$userData.badges[11],
                    badge12: this.$userData.badges[12],
                    married: !!this.$userData.spouse,
                    has_baby: this.$userData.hasBaby,
                }

                this.axios.post('/api/result', params)
                    .then(response => {
                        console.log(response)
                    })
            },

            clearData() {
                localStorage.clear()
                location.reload()
            }
        }
    }
</script>

<style lang="scss" scoped>
    .main-wrap {
        width: 100vw;
        height: 100vh;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #000;
    }
    .game-wrap {
        display: none;
        width: 945px;
        height: 590px;
        overflow: hidden;
        position: relative;

        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;

        &.shake {
            -webkit-animation: shake 0.7s 2 both;
            animation: shake 0.7s 2 both;
            .explode {
                position: absolute;
                top: 0; bottom: 0;
                left: 0; right: 0;
                background: rgba(197, 31, 26, 0.5);
            }
        }

        .game-layout {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            pointer-events: none;

            &>* {
                pointer-events: all;
            }

            .bottom-modules {
                position: absolute;
                bottom: 14px;
                left: 40px;

                .btn-logout {
                    cursor: pointer;
                    margin-right: 6.9px;
                }

                .btn-sound {
                    cursor: pointer;
                }
            }
        }

    }

    .intro-wrap {
        width: 945px;
        height: 590px;
        overflow: hidden;
        position: absolute;
        display: none;

        /*&.show {*/
        /*    -webkit-animation: scale-in-center 0.5s ease-in-out both;*/
        /*    animation: scale-in-center 0.5s ease-in-out both;*/
        /*}*/
        /*&.hide {*/
        /*    -webkit-animation: scale-out-center 0.5s ease-in-out both;*/
        /*    animation: scale-out-center 0.5s ease-in-out both;*/
        /*}*/
    }

    .intro-continued-wrap {
        position: absolute;
        left: 0; right: 0;
        top: 0; bottom: 0;
        display: none;
        pointer-events: none;
    }

    .for-dev {
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
        background-color: #ccc;
        padding: 5px;
        text-align: center;
    }



    /**
 * ----------------------------------------
 * animation shake
 * ----------------------------------------
 */
    @-webkit-keyframes shake {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
            -webkit-transform-origin: 50% 50%;
            transform-origin: 50% 50%;
        }
        10% {
            -webkit-transform: rotate(2deg);
            transform: rotate(2deg);
        }
        20%,
        40%,
        60% {
            -webkit-transform: rotate(-3deg);
            transform: rotate(-3deg);
        }
        30%,
        50%,
        70% {
            -webkit-transform: rotate(3deg);
            transform: rotate(3deg);
        }
        80% {
            -webkit-transform: rotate(-2deg);
            transform: rotate(-2deg);
        }
        90% {
            -webkit-transform: rotate(2deg);
            transform: rotate(2deg);
        }
        99% {
            -webkit-transform: rotate(-3deg);
            transform: rotate(-3deg);
        }
    }
    @keyframes shake {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
            -webkit-transform-origin: 50% 50%;
            transform-origin: 50% 50%;
        }
        10% {
            -webkit-transform: rotate(2deg);
            transform: rotate(2deg);
        }
        20%,
        40%,
        60% {
            -webkit-transform: rotate(-3deg);
            transform: rotate(-3deg);
        }
        30%,
        50%,
        70% {
            -webkit-transform: rotate(3deg);
            transform: rotate(3deg);
        }
        80% {
            -webkit-transform: rotate(-2deg);
            transform: rotate(-2deg);
        }
        90% {
            -webkit-transform: rotate(2deg);
            transform: rotate(2deg);
        }
        99% {
            -webkit-transform: rotate(-3deg);
            transform: rotate(-3deg);
        }
    }

    /**
     * ----------------------------------------
     * animation scale-in-center
     * ----------------------------------------
     */
    @-webkit-keyframes scale-in-center {
        0% {
            -webkit-transform: scale(0);
            transform: scale(0);
            opacity: 1;
        }
        100% {
            -webkit-transform: scale(1);
            transform: scale(1);
            opacity: 1;
        }
    }
    @keyframes scale-in-center {
        0% {
            -webkit-transform: scale(0);
            transform: scale(0);
            opacity: 1;
        }
        100% {
            -webkit-transform: scale(1);
            transform: scale(1);
            opacity: 1;
        }
    }

    /**
     * ----------------------------------------
     * animation scale-out-center
     * ----------------------------------------
     */
    @-webkit-keyframes scale-out-center {
        0% {
            -webkit-transform: scale(1);
            transform: scale(1);
            opacity: 1;
        }
        100% {
            -webkit-transform: scale(0);
            transform: scale(0);
            opacity: 1;
        }
    }
    @keyframes scale-out-center {
        0% {
            -webkit-transform: scale(1);
            transform: scale(1);
            opacity: 1;
        }
        100% {
            -webkit-transform: scale(0);
            transform: scale(0);
            opacity: 1;
        }
    }



</style>
